import React, { useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import searchIcon from '../../images/icon-search.svg';
import notificationIcon from '../../images/icon-notification.svg';
import profileIcon from '../../images/icon-line-user-profile.svg';
import updateIcon from '../../images/icon-update.svg';
import changePasswordIcon from '../../images/icon-change-password.svg';
import logoutIcon from '../../images/icon-logout.svg';
import api from '../../api';
import { logout } from '../../redux/slices/protectSlice';
import {deleteCookie} from '../../utils'; 
 
const AdminHeader = () => {
  const dispatch = useDispatch();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => { return true;
    const savedState = localStorage.getItem('sidebarCollapsed');
    return savedState === 'true';
  });
  
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
  const [isNotificationDropdownOpen, setIsNotificationDropdownOpen] = useState(false);
  
  const profileDropdownRef = useRef(null);
  const notificationDropdownRef = useRef(null);
  const navigate = useNavigate();

  const toggleSidebar = () => {
    setIsSidebarCollapsed((prev) => {
      //const newState = !prev;
      const newState = true;
      localStorage.setItem('sidebarCollapsed', newState);
      return newState;
    });
  };

  const toggleProfileDropdown = () => {
    setIsProfileDropdownOpen((prev) => !prev);
    setIsNotificationDropdownOpen(false);
  };

  const toggleNotificationDropdown = () => {
    setIsNotificationDropdownOpen((prev) => !prev);
    setIsProfileDropdownOpen(false);
  };

  useEffect(() => {
    if (isSidebarCollapsed) {
      document.body.classList.add('collapse-leftbar');
    } else {
      document.body.classList.remove('collapse-leftbar');
    }
  }, [isSidebarCollapsed]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        profileDropdownRef.current &&
        !profileDropdownRef.current.contains(event.target) 
      ) {
        setIsProfileDropdownOpen(false);
        //setIsNotificationDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Function to handle logout
  const handleLogout = async () => {
    try {
      const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/logout`, {}, {});
      if (response.data.status === 'Success') {
        localStorage.removeItem('token');
        dispatch(logout());
        deleteCookie('accessToken');
        navigate('/admin/login');
      } else {
        deleteCookie('accessToken');
        dispatch(logout());
      }
    } catch (error) {
      deleteCookie('accessToken');
      dispatch(logout());
    }
  };

  return (
    <header className="main-header bg-white">
      <a
        id="leftmenu-trigger"
        className="tooltips icon-humburger d-none d-lg-flex"
        data-toggle="tooltip"
        data-placement="right"
        title="Toggle Sidebar"
        onClick={toggleSidebar}
      >
        
      </a>
      <div className="wrap-slide-search">
        <ul className="ul-top">
        {/*
          <li>
            <form id="searchForm">
              <input
                type="text"
                className="form-control-search"
                placeholder="Search"
              />
              <button
                className="border-0 bg-white btn-search-icon"
                type="button"
                id="searchButton"
              >
                <img src={searchIcon} alt="Search" />
              </button>
            </form>
          </li>
          <li ref={notificationDropdownRef}>
            <div className="dropdown-custom">
              <button
                className="border-0 bg-transparent dropdown-toggle"
                type="button"
                aria-expanded={isNotificationDropdownOpen}
                onClick={toggleNotificationDropdown}
              >
                <img src={notificationIcon} alt="Notifications" />
              </button>
              <ul
                className={`dropdown-menu-custom dropdown-menu-end ${isNotificationDropdownOpen ? 'show' : ''}`}
              >
                <li className="dropdown-header">Notifications</li>
                <li className="notification-item">
                  <div className="notification-content">
                    <span className="notification-title">New message from Admin</span>
                    <span className="notification-time">2 min ago</span>
                  </div>
                </li>
                <li className="dropdown-footer">
                  <Link to="/notifications">View all notifications</Link>
                </li>
              </ul>
            </div>
          </li>*/}
          <li ref={profileDropdownRef}>
            <div className="dropdown">
              <button
                className="border-0 bg-transparent dropdown-toggle"
                type="button"
                aria-expanded={isProfileDropdownOpen}
                onClick={toggleProfileDropdown}
              >
                <img src={profileIcon} alt="Profile" />
              </button>
              <ul
                className={`dropdown-menu dropdown-menu-end ${isProfileDropdownOpen ? 'show' : ''}`}
              >
                <li>
                  <Link className="dropdown-item" to="/admin/profile">
                    <img src={updateIcon} alt="Update" />
                    <span>Update Information</span>
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/admin/change-password">
                    <img src={changePasswordIcon} alt="Change Password" />
                    <span>Change Password</span>
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" onClick={handleLogout}>
                    <img src={logoutIcon} alt="Logout" />
                    <span>Logout</span>
                  </Link>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </header>
  );
};

export default AdminHeader;